import { createSlice, current } from '@reduxjs/toolkit';
import states from '../states';

const userStepsDataDetailReducer = createSlice({
  name: 'stepWiseUserDataDetails',
  initialState: {
    ...states.stepWiseUserData,
  },
  reducers: {
    updateStepWiseUserData: (state, action) => {
      let tempState = { ...current(state) };
      let returnableState = {
        ...tempState,
        ...action?.payload,
      };
      sessionStorage.setItem('mm:stepsflow', JSON.stringify(returnableState));
      return { ...returnableState };
    },
    updateStepWiseUserDataForImages: (state, action) => {
      let tempState = { ...current(state) };
      let uploadedImagesState = JSON.parse(
        JSON.stringify(tempState?.stepUploadImages?.files)
      );
      uploadedImagesState[action?.payload?.itemIndex] = {
        ...action?.payload?.itm,
      };

      let returnableState = {
        ...tempState,
        stepUploadImages: {
          ...tempState?.stepUploadImages,
          files: [...uploadedImagesState],
        },
      };
      sessionStorage.setItem('mm:stepsflow', JSON.stringify(returnableState));
      return { ...returnableState };
    },
    deleteImageForStepWiseUserData: (state, action) => {
      let tempState = { ...current(state) };
      let uploadedImagesState = JSON.parse(
        JSON.stringify(tempState?.stepUploadImages?.files)
      );

      let filteredImagesState = uploadedImagesState?.filter(
        (itm) => itm?._id !== action?.payload?.id
      );
      let returnableState = {
        ...tempState,
        stepUploadImages: {
          ...tempState?.stepUploadImages,
          files: [...filteredImagesState],
        },
      };
      sessionStorage.setItem('mm:stepsflow', JSON.stringify(returnableState));
      return { ...returnableState };
    },
    resetForStepWiseUserData: (state, action) => {
      let returnableState = { ...states.stepWiseUserData };
      sessionStorage.setItem('mm:stepsflow', JSON.stringify(returnableState));
      return { ...returnableState };
    },
  },
});

export const {
  updateStepWiseUserData,
  updateStepWiseUserDataForImages,
  deleteImageForStepWiseUserData,
  resetForStepWiseUserData,
} = userStepsDataDetailReducer.actions;
export default userStepsDataDetailReducer;
